import { render, staticRenderFns } from "./SeeFile.vue?vue&type=template&id=5dcbb0b8&scoped=true"
import script from "./SeeFile.vue?vue&type=script&lang=js"
export * from "./SeeFile.vue?vue&type=script&lang=js"
import style0 from "./SeeFile.vue?vue&type=style&index=0&id=5dcbb0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbb0b8",
  null
  
)

export default component.exports